import type { ModelBase } from '../model-base';
import type { ImportValidationErrorsSummary } from '../import-validation';

export const FILEMAGE_FILES_BUCKET_OPIS_FOLDER_NAME = 'opis';
export const SYNC_DATA_SUPPORTED_FILE_CONTENT_TYPES = ['text/csv', 'text/plain'];

export enum SyncDataProcessType {
  OPIS_BIO = 'opis_bio',
  OPIS_RACK = 'opis_rack',
  DTN_PRICES = 'dtn_prices',
  // Copies of the OPIS files Bell's own Ascend downloads, kept as the Bell OPIS feed (SFERP-808).
  // Also the SFTP folder they arrive in, so the SFTP mover forwards them to the import.
  BELL_OPIS = 'bell_opis',

  // Bell's Ascend (PDI) daily extract. One type per entity so each gets its own
  // sync log, its own queue and its own processor - a single type would mix
  // seven unrelated shapes into one log and make a failure impossible to
  // attribute. The file names carry a run stamp (accounts_1789563886.csv), so
  // the settings match on the entity prefix.
  BELL_ASCEND_ACCOUNTS = 'bell_ascend_accounts',
  BELL_ASCEND_LOCATIONS = 'bell_ascend_locations',
  BELL_ASCEND_CONTACTS = 'bell_ascend_contacts',
  BELL_ASCEND_PRODUCTS = 'bell_ascend_products',
  BELL_ASCEND_TAXES = 'bell_ascend_taxes',
  BELL_ASCEND_INVOICES = 'bell_ascend_invoices',
  BELL_ASCEND_DELIVERIES = 'bell_ascend_deliveries',
}

export interface SyncDataProcessLogStats {
  tasksCnt?: number;
  totalRows?: number;
  totalValidRows?: number;
  validationRows?: number;
}

export interface SyncDataProcessLog extends ModelBase, SyncDataProcessLogStats {
  type: SyncDataProcessType;
  fileName?: string;
  fileSize?: string;
  chunkSize: number;
  processedTasks?: number;
  failedTasks?: number;
  processedRows?: number;
  processedValidationRows?: number;
  errorsSummary?: ImportValidationErrorsSummary;
  organizationId?: string;
}

export interface ShowImportValidationErrorsParams {
  syncLog: SyncDataProcessLog;
}
